export default "__VITE_ASSET__4f4c430e__"